import React, { useState } from 'react';
import { CheckCircle, Gift, Users, Award } from 'lucide-react';

const ReferralPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    // Store referral intent — redirect to the public form
    window.location.href = '/referral-submit';
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-slate-800 mb-4" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          Refer 5 Friends — Get a FREE Website
        </h1>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          Share the opportunity with fellow business owners. For every friend who registers, you get one step closer
          to your free professional 1-pager website (worth <strong>R3,997</strong>).
        </p>
      </div>

      {/* How it works */}
      <div className="grid md:grid-cols-3 gap-6 mb-12">
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 text-center">
          <div className="w-16 h-16 bg-[#4a6580]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Gift size={28} className="text-[#4a6580]" />
          </div>
          <h3 className="font-bold text-slate-800 mb-2">1. Get Your Link</h3>
          <p className="text-sm text-slate-600">Sign up and receive your personal referral link to share.</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 text-center">
          <div className="w-16 h-16 bg-[#6e5c25]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Users size={28} className="text-[#6e5c25]" />
          </div>
          <h3 className="font-bold text-slate-800 mb-2">2. Refer 5 Friends</h3>
          <p className="text-sm text-slate-600">Share with 5 business owner friends who register for their free website.</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Award size={28} className="text-green-600" />
          </div>
          <h3 className="font-bold text-slate-800 mb-2">3. Get Your Site</h3>
          <p className="text-sm text-slate-600">Once all 5 register, we build and deploy your free website within 48 hours.</p>
        </div>
      </div>

      {/* Benefits */}
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-slate-100">
        <h2 className="text-2xl font-bold text-slate-800 mb-6" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          Why Refer?
        </h2>
        <div className="grid md:grid-cols-2 gap-4">
          {[
            'Get a professional website worth R3,997 — free',
            'Help fellow entrepreneurs get online',
            'No cost to you or your referrals',
            'Fast 48-hour deployment once qualified',
            'Your own domain with professional branding',
            'Mobile-optimised and SEO-ready',
            'Option to upgrade to Network Membership later',
            'Become a partner and earn commission on referrals',
          ].map((benefit, i) => (
            <div key={i} className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-500 mt-0.5 flex-shrink-0" />
              <span className="text-slate-700">{benefit}</span>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="bg-gradient-to-r from-[#4a6580] to-[#3a5468] rounded-2xl p-8 text-center text-white">
        <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          Ready to Get Your Free Website?
        </h2>
        <p className="mb-6 opacity-90">Start your referral journey today. No credit card required.</p>
        <a
          href="/referral-submit"
          className="inline-block bg-[#6e5c25] hover:bg-[#5a4a1f] text-white font-bold px-10 py-4 rounded-xl transition-all active:scale-[0.98] shadow-lg"
        >
          Start Now
        </a>
      </div>
    </div>
  );
};

export default ReferralPage;
